import { Stack, SvgIconTypeMap, Typography } from "@mui/material";
import "./styles.scss";
import classNames from "classnames";
import { OverridableComponent } from "@mui/material/OverridableComponent";
import { ReactElement } from "react";

export const IconTitleDescription = ({
  icon,
  title,
  description,
  className,
  callToAction,
}: {
  icon: OverridableComponent<SvgIconTypeMap<{}, "svg">>;
  title: string;
  description: string;
  className?: string;
  callToAction?: ReactElement;
}) => {
  const IconComponent = icon;
  return (
    <Stack
      direction={{
        xs: "column",
        md: "row",
      }}
      className={classNames("icon-title-description", className)}
      spacing={2}
      alignItems={{
        xs: "flex-start",
        md: "center",
      }}
      justifyContent="space-between"
    >
      <Stack direction="row" spacing={2} alignItems="center">
        <Stack
          className="icon-circle"
          justifyContent="center"
          alignContent="center"
          alignItems="center"
        >
          <IconComponent />
        </Stack>
        <div className="content">
          <Typography variant="h6" className="title font-body">
            {title}
          </Typography>
          <Typography variant="body1" className="description">
            {description}
          </Typography>
        </div>
      </Stack>
      {callToAction && callToAction}
    </Stack>
  );
};
